import React from 'react';
import { connect } from 'react-redux';

@connect()
export default class rightPanelUpdateBottom extends React.Component {
  render() {
    return (
      <div className=" ui segment ignored info attached message  borderless  max-width brdr-radius-null mrbl">
        <h3 className="ui header">
          <i className="ui circle info icon" />{' '}
        </h3>
        <p>
          <span className="mrts ">
            {APP.LANGUAGE.CreateUpdateGroup.InfoPartOne} {APP.LANGUAGE.CreateUpdateGroup.InfoPartTwo}
          </span>
          <span className="mrtm " />
        </p>
      </div>
    );
  }
}
